var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTreeNewVerde(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 571,
    height: 406,
    viewBox: "0 0 571 406",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.672 114.526C173.969 111.182 167.604 111.182 161.906 114.526L120.036 138.604C114.339 141.948 111.328 147.297 111.328 153.995V202.141C111.328 208.833 114.339 214.182 120.036 217.531L161.906 241.604C167.604 244.953 173.969 244.953 179.672 241.604L221.536 217.531C227.24 214.182 230.245 208.833 230.245 202.141V153.995C230.245 147.297 227.24 141.948 221.536 138.604L179.672 114.526ZM227.24 128.906C236.276 134.255 241.635 143.281 241.635 153.995V202.141C241.635 212.854 236.276 221.88 227.24 227.229L185.359 251.302C176.318 256.651 165.255 256.651 156.219 251.302L114.339 227.229C105.297 221.88 99.9375 212.854 99.9375 202.141V153.995C99.9375 143.281 105.297 134.255 114.339 128.906L156.219 104.828C165.255 99.4687 176.318 99.4687 185.359 104.828L227.24 128.906Z",
    fill: "#3BAE5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M282.081 237.328H289.831V205.214H306.513V197.464H265.399V205.214H282.081V237.328Z",
    fill: "#3BAE5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M315.366 237.328H323.121V205.214H353.569V197.464H323.121L315.366 205.214V237.328Z",
    fill: "#3BAE5B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M370.182 237.328H404.786V229.578H370.182V221.271H395.786V213.521H370.182V205.214H404.786V197.464H370.182L362.427 205.214V229.578L370.182 237.328Z",
    fill: "#3BAE5B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M421.395 237.328H455.999V229.578H421.395V221.271H446.999V213.521H421.395V205.214H455.999V197.464H421.395L413.64 205.214V229.578L421.395 237.328Z",
    fill: "#3BAE5B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M170.672 183.453L170.672 305.245",
    stroke: "#3BAE5B",
    strokeWidth: 12.2402
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M170.714 214.396L212.589 166.135",
    stroke: "#3BAE5B",
    strokeWidth: 12.251
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M144.583 203.214L170.708 234.734",
    stroke: "#3BAE5B",
    strokeWidth: 12.2385
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeNewVerde);
export default __webpack_public_path__ + "static/media/tree-new-verde.3028fb05f5f34e5d2cd8a0350eb279bc.svg";
export { ForwardRef as ReactComponent };